<div class="view-chapters" *ngIf="(chapters$ | async)?.length > 1">
  <div class="view-chapters__header" *ngIf="showHeader">
    <div class="view-chapters__next" (click)="handleNextChapterClick()" *ngIf="nextChapter">
      <span class="text-bold">Next:</span> {{ nextChapter.info.displayName }}
    </div>

    <div class="view-chapters__toggle">
      <app-pin-button 
        icon="list" 
        matTooltip="Table of Contents"
        [selected]="showList"
        (click)="handleToggleList()"></app-pin-button>
    </div>
  </div>

  <ol *ngIf="showList">
    <li 
      class="view-chapters__item"
      *ngFor="let chapter of (chapters$ | async); let i = index;"
      (click)="handleChapterClick(chapter)"
      [ngClass]="{'view-chapters__item--selected': chapter.id === (selectedChapterId$ | async)}">
      
      <div class="view-chapters__index">{{ i + 1 }}.</div>
      <div class="view-chapters__title">{{ chapter.info.displayName }}</div>
      <div class="view-chapters__thumb" [defaultImage]="defaultImage" [lazyLoad]="getChapterThumb(chapter.id)">
      </div>
    </li>
  </ol>
</div>
